import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await login(email, password);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-ivory-100 flex">
      {/* Left: branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-navy-900 text-ivory-200 flex-col justify-center px-16">
        <h1 className="font-display text-display-xl text-white mb-4">
          Osprey Legacy
        </h1>
        <p className="font-body text-lg text-navy-300 leading-relaxed max-w-md">
          Capital planning and estate strategy for advisors who serve family offices that think in generations.
        </p>
        <div className="mt-12 pt-8 border-t border-navy-700">
          <p className="text-sm text-navy-500 font-sans">
            Osprey Analytics
          </p>
        </div>
      </div>

      {/* Right: login form */}
      <div className="flex-1 flex items-center justify-center px-8">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-10">
            <h1 className="font-display text-display-lg text-navy-900">
              Osprey Legacy
            </h1>
          </div>

          <h2 className="font-display text-display-sm text-navy-800 mb-1">
            Welcome back
          </h2>
          <p className="text-sm text-navy-400 font-sans mb-8">
            Sign in to your advisor account
          </p>

          {error && (
            <div className="mb-6 p-3 bg-burgundy-50 border border-burgundy-200 rounded-md">
              <p className="text-sm text-burgundy-600 font-sans">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="email" className="input-label">
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
                placeholder="you@advisorfirm.com"
                required
                autoFocus
              />
            </div>

            <div>
              <label htmlFor="password" className="input-label">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input"
                placeholder="••••••••"
                required
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn-primary w-full"
            >
              {isLoading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-navy-400 font-sans">
            New to Osprey Legacy?{' '}
            <Link
              to="/register"
              className="text-navy-700 font-medium hover:text-navy-900 underline underline-offset-2"
            >
              Create an account
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
